<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <section ref="content" id="content" class="section">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <h4 v-if="!pendingCredits.length" class="title is-size-4 has-text-centered">{{ $t("NoPendingCredits") }}</h4>
          <a v-if="!pendingCredits.length" @click="$router.push(`/tag/info/${_nfcId}`)" class="button is-info is-fullwidth">
                <span class="icon">
                    <i class="fa fa-tag"></i>
                </span>
                <span>{{ $t("ViewTag") }}</span>
          </a>
          <div class="card" v-for="pendingCredit in pendingCredits" :key="pendingCredit.pendingCreditID">
            <div class="card-content">
                <div class="field has-text-centered">
                    <label class="label">{{ $t("TransactionDate") }}</label>
                    <div class="control has-icons-left">
                        <input class="input" :value="new Date(pendingCredit.createdDate).toLocaleString()" type="text" autocomplete="off" readonly>
                        <span class="icon is-small is-left">
                            <i class="fa fa-tag"></i>
                        </span>
                    </div>
                </div>
                <div class="field">
                    <label class="label has-text-centered">{{ $t("PendingCredits") }}</label>
                    <div class="control has-icons-left">
                        <input class="input" type="text" :value="pendingCredit.amount" readonly>
                        <span class="icon is-small is-left">
                            <i class="fa fa-tag"></i>
                        </span>
                    </div>
                </div>
                <div class="field">
                    <label class="label has-text-centered">{{ $t("DeliveringToTap") }}</label>
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <select v-model="pendingCredit.newAssetID" @change="updateAsset(pendingCredit.pendingCreditID)">
                                <option v-for="asset in assets" :key="asset.assetID" :value="asset.assetID" class="status" :class="[asset.connected ? 'Connected' : 'Disconnected']">{{ asset.name }} ({{ asset.connected ? "Connected" : "Disconnected" }})</option>
                            </select>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-tint"></i>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <label class="label has-text-centered">{{ $t("CreditStatus") }}</label>
                    <p v-if="pendingCredit.processed" class="has-text-black">{{ $t("OnTap") }}</p>
                    <p v-else class="has-text-black">{{ $t("OnTap") }}</p>
                </div>
            </div>
            <footer>
                <a @click="moveCredit(pendingCredit)" class="button is-primary is-fullwidth" :disabled="!pendingCredit.enabled">
                    <span class="icon">
                        <i class="fa fa-exchange"></i>
                    </span>
                    <span>{{ $t("MoveCredit") }}</span>
                </a>
                <p v-if="!pendingCredit.enabled" style="text-transform: none" class="has-text-centered">You can only move credits if they have not yet been delivered to the tap</p>
            </footer>
        </div>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "PendingCredits",
  components: {
    Header,
    Notification,
    NavigationTabs,
    Spinner
  },
  props: {
    _nfcId: String
  },
  mounted: async function()
  {
      try
      {
        let response = await this.$http.get(`/Tags/PendingCredits/${this._nfcId.toUpperCase()}`);
        this.pendingCredits = response.data.pendingCredits;

        for(const pendingCredit of this.pendingCredits)
        {
            pendingCredit.newAssetID = pendingCredit.assetID;
            pendingCredit.enabled = false;
        }
        
        if(this.pendingCredits.length)
        {
            response = await this.$http.get(`/Asset?waterSystemId=${this.pendingCredits[0].systemID}`);
            this.assets = response.data.assets;
        }
      }

      catch(error)
        {
            this.$refs.content.scrollTo(0, 0);
            
            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }
  },
  data () {
      return {
          assets: [],
          pendingCredits: []
      }
  },
  methods:
  {
    async moveCredit(pendingCredit)
    {
        if(!pendingCredit.enabled)
        {
            return;
        }

      try
      {
        const response = await this.$http.post(`/Tags/PendingCredits/Move`, {
            oldAssetId: pendingCredit.assetID,
            newAssetId: pendingCredit.newAssetID,
            tagTopupId: pendingCredit.pendingCreditID
        });

        this.notification =
        {
            show: true,
            className: "is-success",
            text: this.$t("CreditSent")
        }
      }

      catch(error)
        {
            this.$refs.content.scrollTo(0, 0);
            
            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }
    },
    updateAsset(pendingCreditID)
    {
        const pendingCredits = this.pendingCredits.slice();
        const pendingCreditIndex = pendingCredits.findIndex(c => c.pendingCreditID == pendingCreditID);
        const asset = this.assets.find(c => c.assetID == pendingCredits[pendingCreditIndex].newAssetID);

        if(pendingCreditIndex != -1 && asset != null && pendingCredits[pendingCreditIndex].newAssetID != pendingCredits[pendingCreditIndex].assetID && asset.connected && pendingCredits[pendingCreditIndex].canMoveCredits)
        {
            pendingCredits[pendingCreditIndex].enabled = true;
        }

        else
        {
            pendingCredits[pendingCreditIndex].enabled = false;
        }

        this.pendingCredits = pendingCredits;
    }
  }
};
</script>
